"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var IoIosWarning_1 = require("@react-icons/all-files/io/IoIosWarning");
var styles_1 = require("../../styles");
function Message(_a) {
    var text = _a.text, _b = _a.className, className = _b === void 0 ? "" : _b, variant = _a.variant, title = _a.title;
    if (variant === "error") {
        return ((0, jsx_runtime_1.jsx)(Container, __assign({ className: className }, { children: (0, jsx_runtime_1.jsxs)(StyledError, __assign({ className: "twap-error-message" }, { children: [(0, jsx_runtime_1.jsx)(IoIosWarning_1.IoIosWarning, { className: "twap-error-message-icon" }), (0, jsx_runtime_1.jsxs)(styles_1.StyledColumnFlex, __assign({ className: "twap-error-message-right" }, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledText, __assign({ className: "twap-error-message-title" }, { children: title })), text && (0, jsx_runtime_1.jsx)(styles_1.StyledText, __assign({ className: "twap-error-message-text" }, { children: text }))] }))] })) })));
    }
    if (variant === "warning") {
        return ((0, jsx_runtime_1.jsx)(Container, __assign({ className: className }, { children: (0, jsx_runtime_1.jsxs)(StyledWarning, __assign({ className: "twap-warning-message" }, { children: [(0, jsx_runtime_1.jsx)(IoIosWarning_1.IoIosWarning, { className: "twap-warning-message-icon" }), (0, jsx_runtime_1.jsx)(styles_1.StyledText, __assign({ className: "twap-warning-message-title" }, { children: title }))] })) })));
    }
    return ((0, jsx_runtime_1.jsx)(Container, __assign({ className: className }, { children: (0, jsx_runtime_1.jsx)(StyledMessage, __assign({ className: "twap-message" }, { children: title })) })));
}
exports.Message = Message;
var Container = (0, styled_components_1.styled)("div")({
    a: {
        color: "rgb(252, 114, 255)",
        textDecoration: "none",
        transition: "opacity 0.2s",
        "&:hover": {
            opacity: 0.8,
        },
    },
});
var StyledMessage = (0, styled_components_1.styled)(styles_1.StyledText)({
    fontSize: 14,
});
var StyledError = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({
    gap: 15,
    alignItems: "center",
    ".twap-error-message-icon": {
        width: 20,
        height: 20,
        color: "rgb(255, 95, 82)",
    },
    ".twap-error-message-right": {
        gap: 0,
        flex: 1,
        width: "auto",
    },
    ".twap-error-message-title": {
        fontSize: 16,
        lineHeight: "23px",
    },
    ".twap-error-message-text": {
        fontSize: 14,
        lineHeight: "19px",
    },
});
var StyledWarning = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({
    alignItems: "flex-start",
    ".twap-warning-message-icon": {
        width: 20,
        height: 20,
    },
    ".twap-warning-message-title": {
        fontSize: 14,
        lineHeight: "19px",
        flex: 1,
    },
});
